import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RolePermission, RolePermissionMatrix } from '../../helpers/permissions';
import { PermissionsExtendedState, PermissionsExtendedStatus, SetMatrixRolePermissionPayload } from './types';

const initialState: PermissionsExtendedState = {
    presetId: 'default',
    matrix: {},
    matrixOverride: null,
    status: null,
    nonConfigurablePermissions: [],
    haveChangedFromDefault: false,
};

const permissionsExtendedSlice = createSlice({
    name: 'permissionsExtended',
    initialState,
    reducers: {
        setPermissionsExtendedMatrix(state: PermissionsExtendedState, action: PayloadAction<RolePermissionMatrix>) {
            state.matrix = action.payload;
        },
        resetPermissionsExtendedMatrix(state: PermissionsExtendedState) {
            state.matrix = {};
        },
        setPermissionsExtendedMatrixOverrideRolePermission(
            state: PermissionsExtendedState,
            action: PayloadAction<SetMatrixRolePermissionPayload>
        ) {
            const { role, rolePermission, value } = action.payload;
            if (!state.matrixOverride) {
                state.matrixOverride = {};
            }
            if (!state.matrixOverride[role]) {
                state.matrixOverride[role] = {};
            }
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            state.matrixOverride[role]![rolePermission] = value;
        },
        resetPermissionsExtendedMatrixOverride(state: PermissionsExtendedState) {
            state.matrixOverride = null;
        },
        setPermissionsExtendedStatus(
            state: PermissionsExtendedState,
            action: PayloadAction<PermissionsExtendedStatus>
        ) {
            state.status = action.payload;
        },
        resetPermissionsExtendedStatus(state: PermissionsExtendedState) {
            state.status = null;
        },
        setPermissionExtendedPresetId(state: PermissionsExtendedState, action: PayloadAction<string>) {
            state.presetId = action.payload;
        },
        setNonConfigurablePermissions(state: PermissionsExtendedState, action: PayloadAction<RolePermission[]>) {
            state.nonConfigurablePermissions = action.payload;
        },
        setPermissionExtendedHaveChangedFromDefault(state: PermissionsExtendedState, action: PayloadAction<boolean>) {
            state.haveChangedFromDefault = action.payload;
        },
    },
});

export const {
    setPermissionsExtendedMatrix,
    resetPermissionsExtendedMatrix,
    setPermissionsExtendedMatrixOverrideRolePermission,
    resetPermissionsExtendedMatrixOverride,
    setPermissionsExtendedStatus,
    resetPermissionsExtendedStatus,
    setPermissionExtendedPresetId,
    setNonConfigurablePermissions,
    setPermissionExtendedHaveChangedFromDefault,
} = permissionsExtendedSlice.actions;

export const loadPermissionsExtendedMatrixAction = createAction(
    '@permissionsExtended/loadPermissionsExtendedMatrixAction'
);
export const resetPermissionsExtendedAction = createAction('@permissionsExtended/resetPermissionsExtendedAction');

export const permissionsExtendedReducer = permissionsExtendedSlice.reducer;
